/**
 * Apple requires unlocking AI Credits on iOS to go through In-App Purchase
 * (App Review Guideline 3.1.1). App Store Connect consumable product
 * identifiers follow the convention `{PREFIX}{credits}` - e.g. 700 credits
 * is `co.carata.business.aicredit.700`. Keep this prefix in sync with the
 * backend's `appstore.apps.business.product_id_prefix` config value.
 *
 * This is the business (seller) app - it's registered as its own separate
 * app in App Store Connect, with its own Bundle ID (co.carata.business) and
 * its own set of IAP products, distinct from the consumer app's. This
 * app's prefix (`co.carata.business.aicredit.`) is what the backend uses
 * to recognise a purchase as coming from here rather than the consumer
 * app, so there's no need to separately tell it which app this is.
 *
 * Which credit amounts are actually purchasable is NOT hardcoded here -
 * it comes from the backend's `ai_credit_appstore_packages` system
 * setting (delivered as `window.systemConfigs.aiCreditAppStorePackages`,
 * shared with the consumer app), so packages can change without an app
 * release. Each amount still needs a matching consumable product created
 * under this app's own entry in App Store Connect.
 */
export const APPSTORE_PRODUCT_ID_PREFIX = "co.carata.business.aicredit.";

export function appStoreProductIdForCredits(credits) {
    return `${APPSTORE_PRODUCT_ID_PREFIX}${credits}`;
}

export function availableAppStorePackages() {
    const raw = window.systemConfigs?.aiCreditAppStorePackages ?? [];

    return raw
        .map((credits) => parseInt(credits, 10))
        .filter((credits) => Number.isFinite(credits) && credits > 0);
}
